import { render } from "./JoinPublicationTwoFactor.vue.js?vue&type=template&id=670ff4ae!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./JoinPublicationTwoFactor.vue?vue&type=template&id=670ff4ae"
import script from "./JoinPublicationTwoFactor.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./JoinPublicationTwoFactor.vue?vue&type=script&lang=js"
export * from "./JoinPublicationTwoFactor.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./JoinPublicationTwoFactor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-pages/login-signup-page/join-publication/JoinPublicationTwoFactor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "670ff4ae"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('670ff4ae', __exports__)) {
    api.reload('670ff4ae', __exports__)
  }
  
  module.hot.accept("./JoinPublicationTwoFactor.vue.js?vue&type=template&id=670ff4ae!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./JoinPublicationTwoFactor.vue?vue&type=template&id=670ff4ae", () => {
    api.rerender('670ff4ae', render)
  })

}


export default __exports__